<div class="container" id="spinerLoader" *ngIf="vendorLoader">
  <div class="loader">Loading...</div>
</div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="vendorDetail" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header content-header">
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close"
          (click)="closeVendorModel(f)">
          <i class="fa fa-close fa-md"></i>
        </button>
        <h4 class="modal-title">{{ modalHeader }} Vendor</h4>
      </div>
      <form name="form" #f="ngForm" novalidate>
        <div class="modal-body">
          <div class="member-card">
            <h4 class="filter-options mt-0">Personal Information</h4>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Vendor Name<span class="text-danger">*</span></label>
                  <input type="text" id="vehiclename" placeholder="Vendor Name" name="vehicle_name"
                    #vehicle_name="ngModel" class="form-control" [(ngModel)]="vendorDetail.name" maxlength="100"
                    [ngClass]="{ 'is-invalid': f.submitted && vehicle_name.invalid }" required />
                  <div *ngIf="f.submitted && vehicle_name.invalid" class="invalid-feedback">
                    <div *ngIf="vehicle_name.errors.required"> <span style="color: red;">Vendor Name is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Priority<span class="text-danger">*</span></label>
                  <select name="priority" class="form-control" #priority="ngModel" [(ngModel)]="vendorDetail.priority"
                    [ngClass]="{ 'is-invalid': f.submitted && priority.invalid }" required>
                    <option *ngFor="let priority of priorityList" [ngValue]="priority.id">
                      {{ priority.name }}
                    </option>
                  </select>
                  <div *ngIf="f.submitted && priority.invalid" class="invalid-feedback">
                    <div *ngIf="priority.errors.required"><span style="color: red;">Priority is required.</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Email<span class="text-danger">*</span></label>
                  <input type="text" id="email" placeholder="Email" name="email" #email="ngModel" class="form-control"
                    maxlength="50" [(ngModel)]="vendorDetail.contact.emailId"
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
                  <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                    <div *ngIf="email.errors.required"><span style="color: red;">Email is required.</span></div>
                    <div *ngIf="email.errors.email"><span style="color: red;">Email must be a valid email
                        address.</span></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Phone<span class="text-danger">*</span></label>
                  <input type="text" id="addMobileNumber" placeholder="(xxx) xxx-xxxx" name="add_MobileNumber"
                    #add_MobileNumber="ngModel" maxlength="14" minlength="14" pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+"
                    (ngModelChange)="vendorDetail.contact.phoneNumber=$event" class="form-control"
                    [ngModel]="vendorDetail.contact.phoneNumber |phoneNumberPipe"
                    [ngClass]="{ 'is-invalid': f.submitted && add_MobileNumber.invalid }" required />
                  <div *ngIf="f.submitted && add_MobileNumber.invalid" class="invalid-feedback">
                    <div *ngIf="add_MobileNumber.errors.required"><span style="color: red;">Phone Number is
                        required.</span></div>
                    <div *ngIf="add_MobileNumber.errors.minlength"><span style="color: red;">Phone must have 10
                        digits.</span></div>
                    <div *ngIf="add_MobileNumber.errors.pattern"><span style="color: red;">Phone Number not
                        valid.</span></div>
                  </div>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Transport Type<span class="text-danger">*</span></label>
                  <div class="form-check">
                    <span *ngFor="let serviceTypes of serviceType; let i = index">
                      <input type="checkbox" class="form-check-input" id="exampleCheck{{ i }}" name="transport_type"
                        [value]="serviceTypes.type" [checked]="serviceTypes.check"
                        (change)="serviceTypes.check = !serviceTypes.check" />
                      <label class="form-check-label pl-2 mr-4 cursorPointer" style="font-weight: 400"
                        for="exampleCheck{{ i }}">{{ serviceTypes.type }}</label>
                    </span>
                    <div class="invalid-feedback" *ngIf="!fromValid">
                      <span style="color: red;">Transport Type is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Contracted<span class="text-danger">*</span></label>
                  <div class="radio my-0">
                    <label><input type="radio" name="contract" [value]="true" [(ngModel)]="vendorDetail.isContracted"
                        #contract='ngModel' required />Yes</label>
                    <label class="ml-4"><input type="radio" name="contract" [value]="false"
                        [(ngModel)]="vendorDetail.isContracted" #contract='ngModel' required />No</label>
                  </div>
                  <div *ngIf="f.submitted && contract.invalid" class="invalid-feedback">
                    <div *ngIf="contract.errors.required"><span style="color: red;">Contracted is required.</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="member-card">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h4 class="filter-options mt-0">Service Area</h4>
              </div>
              <button class="text-color btn btn-link py-0" (click)="addServiceArea()" [disabled]="vendorDetail.isNationwideEnabled">
                <i aria-hidden="true" class="fa fa-plus-circle mr-2"></i>
                <b>New</b>
              </button>
            </div>

            <div class="row">
              <div class="col-lg-1 d-flex align-items-center my-2">
                <input class="m-0"
                       type="checkbox"
                       id="isNationwide"
                       [(ngModel)]="vendorDetail.isNationwideEnabled"
                       [ngModelOptions]="{ standalone: true }"
                       (ngModelChange)="onIsNationwideToggle($event)">
                    <label class="m-0 ml-2 font-weight-500 line-height-2" for="isNationwide">
                    Nationwide
                </label>
              </div>
            </div>

            <ng-container *ngIf="!vendorDetail.isNationwideEnabled">
              <div class="row" *ngFor="let service of vendorServiceArea; let i = index">
              <div class="col-md-6">
                <div class="form-group">
                  <label>State<span class="text-danger">*</span></label>
                  <select name="state{{ i }}" class="form-control" id="state{{ i }}" (change)="selectState($event, i)"
                    #state="ngModel" [(ngModel)]="service.stateId"
                    [ngClass]="{ 'is-invalid': f.submitted && state.invalid }" required>
                    <option value="" selected disabled>Select State</option>
                    <option *ngFor="let state of stateList" [value]="state?.stateId">
                      {{ state?.stateName }}
                    </option>
                  </select>
                  <div *ngIf="f.submitted && state.invalid" class="invalid-feedback">
                    <div *ngIf="state.errors.required"><span style="color: red;">State is required.</span></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="d-flex justify-content-between"><span>City<span class="text-danger">*</span></span><span
                      class="mr-1 text-color cursorPointer" title="Remove Service Area"
                      *ngIf="vendorServiceArea.length>1" (click)="removeServiceArea(i)">
                      <i class="fa fa-minus-circle"></i></span></label>
                  <ng-multiselect-dropdown-angular7 [placeholder]="'Select City'" [settings]="dropdownSettings"
                    [data]="service.cityList" class="showAllOption" #city="ngModel" [(ngModel)]="service.city" ngModel
                    name="city{{ i }}" [ngClass]="{ 'is-invalid': f.submitted && city.invalid }"
                    (onSelectAll)="onSelectAll($event)" required>
                  </ng-multiselect-dropdown-angular7>
                  <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                    <div *ngIf="city.errors.required"><span style="color: red;">City is required.</span></div>
                  </div>
                </div>
              </div>
            </div>
            </ng-container>
          </div>

          <div class="member-card">
            <h4 class="filter-options mt-0">Address Details</h4>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Address Type</label><span class="text-danger"> * </span>
                  <select name="addressType" #addressType="ngModel" class="form-control"
                    [(ngModel)]="vendorDetail.address.addressLocationType"
                    [ngClass]="{ 'is-invalid': f.submitted && addressType.invalid }" required>
                    <option [value]="null" selected disabled>Select Address Type</option>
                    <option *ngFor="let item of AddressType" [value]="item" name="addr_type">
                      {{item}}
                    </option>
                  </select>
                  <div *ngIf="f.submitted && addressType.invalid" class="invalid-feedback">
                    <div *ngIf="addressType.errors.required"><span style="color: red;">Address Type is
                        required.</span></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Address</label><span class="text-danger"> * </span>
                  <div class="radio my-0">
                    <label><input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                        [(ngModel)]="vendorDetail.address.isGlobal" [value]="false" required />Private</label>
                    <label class="ml-4"><input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                        [(ngModel)]="vendorDetail.address.isGlobal" [value]="true" required />Public</label>
                    <div *ngIf="f.submitted && pvtOrPublic.invalid" class="invalid-feedback">
                      <div *ngIf="pvtOrPublic.errors.required"><span style="color: red;">Field is
                          required.</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Street Address</label>
                  <input type="text" name="streetAddress" id="CMStreetAddress" placeholder="Street Address"
                    maxlength="150" class="form-control" [(ngModel)]="vendorDetail.address.streetAddress" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Zipcode</label>
                  <input type="text" id="CMZipcode" placeholder="Zipcode" name="Zipcode" class="form-control"
                    maxlength="5" minlength="3" pattern="[A-Za-z0-9]+" [(ngModel)]="vendorDetail.address.zipcode"
                    #zipCode="ngModel" />
                  <div *ngIf="f.submitted && zipCode.invalid" class="invalid-feedback">
                    <div *ngIf="zipCode.errors.pattern">
                      <span style="color: red;">ZipCode not valid.</span>
                    </div>
                    <div *ngIf="zipCode.errors.minlength">
                      <span style="color: red;">ZipCode must have 3 or 5 digits.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>State<span class="text-danger">*</span></label>

                  <select name="state_add" class="form-control" [(ngModel)]="vendorDetail.address.stateId"
                    #state_add="ngModel" (change)="getCityByState(vendorDetail.address.stateId)"
                    [ngClass]="{ 'is-invalid': f.submitted && state_add.invalid }" required>
                    <option value="" selected disabled>Select State</option>
                    <option *ngFor="let item of stateList" [value]="item.stateId" name="state">
                      {{ item?.stateName }}
                    </option>
                  </select>
                  <div *ngIf="f.submitted && state_add.invalid" class="invalid-feedback">
                    <div *ngIf="state_add.errors.required"><span style="color: red;">State is required.</span></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>City<span class="text-danger">*</span></label>

                  <select name="city" #city="ngModel" class="form-control" [(ngModel)]="vendorDetail.address.city"
                    [ngClass]="{ 'is-invalid': f.submitted && city.invalid }" required>
                    <option value="" selected disabled>Select City</option>
                    <option *ngFor="let addCity of cityList" [value]="addCity.cityName">
                      {{ addCity.cityName }}
                    </option>
                  </select>
                  <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                    <div *ngIf="city.errors.required"><span style="color: red;">City is required.</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="member-card" *ngIf="header != 'Edit Customer'">
            <h4 class="filter-options my-0">Files</h4>
            <div class="float-right mb-3">
              <input type="file" class="cursorPointer mt-2" accept=".jpg,.jpeg,.png,.pdf" id="vendorFileUpdate" multiple
                #fileInput [(ngModel)]="vendorFile" name="vendorFile"
                (input)="vendorFileUpload(vendorFile,'vendorFileUpdate')" style="display: none" />
              <a class="py-2 px-3 mr-2 button_style cursorPointer" *ngIf="!editAllFile1" (click)="editVendorFileOpen()">
                Add File
              </a>
              <a class="py-2 px-3 mr-2 button_style_edit cursorPointer" (click)="editAllFile()"
                *ngIf="chooseFile.length != 0 && !editAllFile1">Edit File</a>
              <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                *ngIf="editAllFile1" (click)="closeAll()">
                <i class="fa fa-close fa-md"></i>
              </button>
              <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                *ngIf="editAllFile1" (click)="closeViewFileModel()">
                <i class="fa fa-check fa-md"></i>
              </button>
            </div>
            <div class="tableMargin">
              <table class="table border-table" data-sort="false" id="tblattach">
                <thead class="table-thead">
                  <tr>
                    <td class="header_td p-2" style="border-bottom: 1px !important">
                      <div class="header_container">
                        <div class="header_title" style="width: 29.33%">
                          File Name
                        </div>
                        <div class="header_title" style="width: 40.33%">
                          File Type
                        </div>
                        <div class="header_title action">Action</div>
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                      let file of chooseFile | SearchByName: searchText1;
                      let i = index
                    ">
                    <td>
                      <div class="row_container">
                        <div class="title_container" [style.width]="
                            isMobileDevice == true ? '30.33%' : '100%'
                          ">
                          <div class="row_title">File Name</div>
                          <div class="row_detail text-color cursorPointer" style="word-break: break-word"
                            *ngIf="!file.IsEditable" (click)="downloadFile(file)">
                            {{ file.fileName }}.{{ file.extension }}
                          </div>
                          <div *ngIf="file.IsEditable" class="d-flex">
                            <input type="text" placeholder="File Name" class="form-control mr-2"
                              [(ngModel)]="file.fileName" name="file_name_edit{{ i }}" id="file_name_edit{{ i }}" />
                            <span class="mt-2"><b>.{{ file?.extension }}</b></span>
                          </div>
                        </div>
                        <div class="title_container" [style.width]="
                            isMobileDevice == true ? '40.33%' : '100%'
                          ">
                          <div class="row_title">File Type</div>
                          <input type="text" class="form-control" *ngIf="file.IsEditable" [(ngModel)]="file.fileType"
                            id="file_category_edit{{ i }}" name="file_category_edit{{ i }}" />
                          <div class="row_detail" style="word-break: break-word" *ngIf="!file.IsEditable">
                            {{ file?.extension }}
                          </div>
                        </div>
                        <div class="title_container">
                          <div class="row_title">Action</div>
                          <div class="row_detail">
                            <button class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                              *ngIf="!file.IsEditable" title="Edit License" (click)="fileEdit(i)">
                              <i class="fa fa-pencil-square"></i>
                            </button>
                            <button class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                              *ngIf="!file.IsEditable" data-target="#message" data-toggle="modal"
                              title="Remove{{ file.fileType }}file" (click)="removeFileForPopup(i)">
                              <i class="fa fa-minus-circle"></i>
                            </button>
                            <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                              *ngIf="file.IsEditable" (click)="closeDisable(i)">
                              <i class="fa fa-close fa-md"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
            data-dismiss="modal" (click)="closeVendorModel(f)">
            Cancel
          </button>
          <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
            (click)="submitVendorData(f)">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
